/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreImagesResponse } from '../../models/store-images-response';

export interface StoreImagesGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
}

export function storeImagesGet(http: HttpClient, rootUrl: string, params: StoreImagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreImagesResponse>> {
  const rb = new RequestBuilder(rootUrl, storeImagesGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreImagesResponse>;
    })
  );
}

storeImagesGet.PATH = '/stores/{storeId}/images';
